export class AppResponseData {
  public logToken!: string;
  public version?: string;
  public appCode!: number;
  public appDetail?: string;
}

export class ResponseMessages extends AppResponseData {
  public data!: any[];
  public total?: number;
}

export class ResponseMessagesObject extends AppResponseData {
  public data!: any;
  public total?: number;
}

export class ResponseMessage extends AppResponseData {
  public data!: string;
}

export interface ResponseCode {
  appCode: number;
  appDetail: string;
  data: string;
}
